import FalconCloseButton from 'components/common/FalconCloseButton';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row, Spinner, Card, Badge, Form } from 'react-bootstrap';
import useToken from '../../../hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const ModalModulosPRONuevaOrden = ({
    show,
    setShow,
    idLicencia,
    setModulosProVinculados // callback para continuar el flujo
}) => {
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const [productos, setProductos] = useState([]);
    const [renovaciones, setRenovaciones] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [cargandoRenovaciones, setCargandoRenovaciones] = useState(false);
    const [productoSeleccionado, setProductoSeleccionado] = useState(null);
    const [renovacionSeleccionada, setRenovacionSeleccionada] = useState(null);
    const [precioUnitario, setPrecioUnitario] = useState(0);
    const [iva, setIVA] = useState(0);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        if (show) {
            cargarProductos();
        }
    }, [show]);

    // Cambia el endpoint para productos modulos
    const cargarProductos = async () => {
        setCargando(true);
        try {
            const response = await fetch("/api/licencia/ObtenerProductosModulos", {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) throw new Error('Error al cargar productos');
            const data = await response.json();
            setProductos(data);
        } catch (error) {
            showErrorToast(error.message);
        }
        setCargando(false);
    };

    // Cargar renovaciones cuando se selecciona un producto de renovación
    const cargarRenovaciones = async (idProducto) => {
        setCargandoRenovaciones(true);
        try {
            const response = await fetch('/api/licencia/GetRenovacionesByProducto?idProducto=' + idProducto, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) throw new Error('Error al cargar renovaciones');
            const data = await response.json();

            if (Array.isArray(data)) {
                const responseTable = JSON.parse(data[0]); 

                if (Array.isArray(responseTable) && responseTable.length > 0) {
                    const responseData = responseTable[0];

                    if (responseData.iResponseType === 1) {
                        const renovacionesTable = JSON.parse(data[1]);
                        setRenovaciones(Array.isArray(renovacionesTable) ? renovacionesTable : []);
                    } else {
                        // Error desde el SP
                        setRenovaciones([]);
                        showErrorToast(responseData.vMessage || 'Error al obtener renovaciones');
                    }
                } else {
                    setRenovaciones([]);
                    showErrorToast('Formato de respuesta inesperado');
                }
            } else {
                setRenovaciones([]);
                showErrorToast('No se recibieron datos válidos del servidor');
            }
        } catch (error) {
            showErrorToast(error.message);
            setRenovaciones([]);
        }
        setCargandoRenovaciones(false);
    };

    const handleSelectProducto = (producto) => {
        setProductoSeleccionado(producto);
        setRenovacionSeleccionada(null);
        setRenovaciones([]);

        // Si es renovación, cargar las opciones disponibles
        if (producto.bIsPeriodicidad) {
            cargarRenovaciones(producto.idProducto);
        } else {
            // Si es pago único, permite editar el total 
            setTotal(producto.dTotal || 0);
            setPrecioUnitario(producto.dPrecioUnitario || 0);
            setIVA(producto.dIVA || 0);
        }
    };

    const handleSelectRenovacion = (e) => {
        const renovacionId = parseInt(e.target.value);
        if (renovacionId) {
            const renovacion = renovaciones.find(r => r.idProductoRenovaciones === renovacionId);
            if (renovacion) {
                setRenovacionSeleccionada(renovacion);
                setPrecioUnitario(renovacion.dPrecioUnitario || 0);
                setIVA(renovacion.dIVA || 0);
                setTotal(renovacion.dTotal || 0);
            }
        } else {
            setRenovacionSeleccionada(null);
            setPrecioUnitario(0);
            setIVA(0);
            setTotal(0);
        }
    };

    const handleTotalChange = (e) => {
        const value = parseFloat(e.target.value) || 0;
        setTotal(value);
        const precioCalc = value / 1.16;
        const ivaCalc = value - precioCalc;
        setPrecioUnitario(precioCalc);
        setIVA(ivaCalc);
    };

    // Nueva función para crear la orden y asignar el módulo PRO, con lógica y manejo de respuesta igual a onSubmitAsignarModulo
    const crearOrdenNuevaParaModuloPRO = async () => {
        if (!productoSeleccionado) {
            showErrorToast("Debes seleccionar el producto antes de continuar.");
            return;
        }

        setCargando(true);
        // Construir el body con los parámetros requeridos
        let body = {
            idLicencia: idLicencia,
            idProducto: productoSeleccionado.idProducto,
            dPrecioUnitario: precioUnitario,
            dTasaCuotaIVA: 0.16, // Ajusta si tienes el valor real
            vTipoFactorIVA: 'Tasa', // Ajusta si tienes el valor real
            dIVA: iva,
            dTotal: total
        };
        try {
            const response = await fetch('/api/licencia/CrearOrdenNuevaParaModuloPRO', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType == 1) {
                    setModulosProVinculados(JSON.parse(data.detalles));
                    showSuccessToast(data.vMessage);
                } else {
                    showErrorToast(data.vMessage || 'Error al crear la orden');
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la petición Fetch: ' + error);
        }
        setShow(false);
        setCargando(false);
    };

    // Modifica el handleSeleccionar para llamar a la función de crear orden
    const handleSeleccionar = () => {
        crearOrdenNuevaParaModuloPRO();
    };

    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName="modal-dialog-scrollable"
            style={{ maxHeight: '90vh' }}
        >
            <Modal.Header className="pb-2">
                <Modal.Title>
                    Selecciona un producto para la nueva orden
                </Modal.Title>
                <FalconCloseButton
                    className="btn btn-circle btn-sm transition-base p-0"
                    onClick={() => setShow(false)}
                />
            </Modal.Header>

            <Modal.Body className="p-0 d-flex flex-column" style={{ height: '70vh', minHeight: '500px' }}>
                {/* SECCIÓN DE LISTA DE PRODUCTOS - 50% de altura */}
                <div style={{ height: '65%', borderBottom: '2px solid #e9ecef' }} className="p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0 fw-bold text-primary">Lista de Productos</h6>
                        {productos.length > 0 && (
                            <Badge bg="info">{productos.length} productos</Badge>
                        )}
                    </div>

                    <div style={{ height: 'calc(100% - 40px)', overflowY: 'auto' }}>
                        {cargando ? (
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <div className="text-center">
                                    <Spinner animation="border" variant="primary" size="sm" />
                                    <div className="mt-2 small">Cargando productos...</div>
                                </div>
                            </div>
                        ) : (
                            <div className="d-flex flex-column gap-2">
                                {productos.map((producto, idx) => (
                                    <Card
                                        key={idx}
                                        className={`border cursor-pointer transition-base ${productoSeleccionado && productoSeleccionado.idProducto === producto.idProducto
                                            ? 'border-success border-2 bg-success bg-opacity-10'
                                            : 'border-light hover-border-primary'
                                            }`}
                                        onClick={() => handleSelectProducto(producto)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <Card.Body className="p-2">
                                            <Row className="align-items-center">
                                                <Col xs={8}>
                                                    <div className="fw-bold text-primary mb-1" style={{ fontSize: '0.9rem' }}>
                                                        {producto.vNombreProducto}
                                                    </div>
                                                    <div className="mb-1">
                                                        <Badge
                                                            bg={producto.bIsPeriodicidad ? 'warning' : 'info'}
                                                            className="me-1"
                                                            style={{ fontSize: '0.7rem' }}
                                                        >
                                                            {producto.bIsPeriodicidad ? 'Renovación' : 'Pago Único'}
                                                        </Badge>
                                                        <Badge
                                                            bg={producto.bServicio ? 'secondary' : 'success'}
                                                            style={{ fontSize: '0.7rem' }}
                                                        >
                                                            {producto.bServicio ? 'Servicio' : 'Producto'}
                                                        </Badge>
                                                    </div>
                                                    <div className="small text-muted">
                                                        {producto.vCodigoBarras}
                                                    </div>
                                                </Col>
                                                <Col xs={4} className="text-end">
                                                    <div className="fw-bold text-success" style={{ fontSize: '0.7rem' }}>
                                                        Precio Uni: ${parseFloat(producto.dPrecioUnitario).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                                    </div>
                                                    <div className="fw-bold text-primary" style={{ fontSize: '0.9rem' }}>
                                                        Total: ${parseFloat(producto.dTotal).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* SECCIÓN DE PRODUCTO SELECCIONADO - 50% de altura */}
                <div style={{ height: '35%' }} className="p-1 d-flex flex-column">
                    <h6 className="mb-0 fw-bold text-secondary text-center">Producto Seleccionado</h6>

                    {productoSeleccionado ? (
                        <div className="flex-grow-0 d-flex flex-column">
                            {/* Información del producto */}
                            <div className="text-center mb-0">
                                <div className="fw-bold text-primary mb-1" style={{ fontSize: '1rem' }}>
                                    {productoSeleccionado.vNombreProducto}
                                </div>
                            </div>

                            {/* Precios */}
                            <div className="flex-grow-0 d-flex flex-column justify-content-center">
                                {!productoSeleccionado.bIsPeriodicidad ? (
                                    <div className="text-center">
                                        <label className="form-label fw-bold mb-0">Total Final:</label>
                                        <Form.Control
                                            type="number"
                                            min={0}
                                            step={0.01}
                                            value={total}
                                            onChange={handleTotalChange}
                                            className="text-center mb-2"
                                            style={{ maxWidth: '200px', margin: '0 auto', fontSize: '1rem' }}
                                        />
                                        <Row className="text-center">
                                            <Col xs={6}>
                                                <div className="small text-muted">Precio Base</div>
                                                <div className="fw-bold">${precioUnitario.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</div>
                                            </Col>
                                            <Col xs={6}>
                                                <div className="small text-muted">IVA</div>
                                                <div className="fw-bold">${iva.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</div>
                                            </Col>
                                        </Row>
                                    </div>
                                ) : (
                                    <div className="text-center">
                                        <label className="form-label fw-bold mb-1 small">Tipo de Renovación:</label>
                                        {cargandoRenovaciones ? (
                                            <div className="d-flex justify-content-center mb-2">
                                                <Spinner animation="border" size="sm" variant="primary" />
                                            </div>
                                        ) : (
                                            <Form.Select
                                                value={renovacionSeleccionada?.idProductoRenovaciones || ''}
                                                onChange={handleSelectRenovacion}
                                                className="text-center mb-2"
                                                style={{ maxWidth: '250px', margin: '0 auto', fontSize: '0.9rem' }}
                                            >
                                                <option value="">-- Seleccionar renovación --</option>
                                                {renovaciones.map((renovacion) => (
                                                    <option key={renovacion.idProductoRenovaciones} value={renovacion.idProductoRenovaciones}>
                                                        {renovacion.vTipoRenovacion} - ${parseFloat(renovacion.dTotal).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        )}

                                        {renovacionSeleccionada && (
                                            <Row className="text-center">
                                                <Col xs={4}>
                                                    <div className="small text-muted">Precio</div>
                                                    <div className="fw-bold">${parseFloat(renovacionSeleccionada.dPrecioUnitario).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</div>
                                                </Col>
                                                <Col xs={4}>
                                                    <div className="small text-muted">IVA</div>
                                                    <div className="fw-bold">${parseFloat(renovacionSeleccionada.dIVA).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</div>
                                                </Col>
                                                <Col xs={4}>
                                                    <div className="small text-muted">Total</div>
                                                    <div className="fw-bold text-primary">${parseFloat(renovacionSeleccionada.dTotal).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</div>
                                                </Col>
                                            </Row>
                                        )}
                                    </div>
                                )}

                                {!productoSeleccionado.bServicio && (
                                    <div className="text-center mt-2">
                                        <span className="small text-muted">Existencia: </span>
                                        <span className="fw-bold">{productoSeleccionado.dExistencia}</span>
                                    </div>
                                )}
                            </div>

                            {/* Botón seleccionar */}
                            <div className="text-center mt-3">
                                <Button
                                    onClick={handleSeleccionar}
                                    variant='primary'
                                    size="md"
                                    className="px-4"
                                    disabled={!productoSeleccionado || (productoSeleccionado.bIsPeriodicidad && !renovacionSeleccionada)}
                                >
                                    Seleccionar Producto
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                            <div className="text-center text-muted">
                                <div style={{ fontSize: '3rem', opacity: 0.3 }}>📋</div>
                                <div>Selecciona un producto de la lista superior</div>
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Body>

            <Modal.Footer className="pt-2 justify-content-between">
                <Button
                    onClick={() => setShow(false)}
                    variant='secondary'
                    size="sm"
                >
                    Cancelar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ModalModulosPRONuevaOrden.propTypes = {
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    idLicencia: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setModulosProVinculados: PropTypes.func
};

export default ModalModulosPRONuevaOrden;